import { useQuery } from "react-admin";

const ADMIN_ROLES = ["superadmin", "admin"];

export const normalizeRoleName = (role) => {
  const name = typeof role === "string" ? role : role?.name;
  return String(name || "")
    .toLowerCase()
    .replace(/\s+/g, "");
};

export const canManageUserPassword = (currentUser) => {
  const roles = currentUser?.roles || [];
  return roles.some((role) => ADMIN_ROLES.includes(normalizeRoleName(role)));
};

export const useCanManageUserPassword = () => {
  const { data: currentUser, loading } = useQuery({
    type: "getOne",
    resource: "me",
    payload: { id: "" },
  });

  return {
    loading,
    canManage: !loading && canManageUserPassword(currentUser),
  };
};
